import React from 'react';
import { su } from './stockUi';

export function parseNumber(value, fallback = 0) {
  if (value === '' || value === null || value === undefined) return fallback;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(n) ? n : fallback;
}

const NumberField = ({
  name,
  value,
  onChange,
  className = su.input,
  ...rest
}) => {
  const display = value === 0 || value === '0' ? '' : value ?? '';

  return (
    <input
      type="number"
      inputMode="decimal"
      name={name}
      value={display}
      onChange={onChange}
      onFocus={(e) => e.target.select()}
      className={className}
      {...rest}
    />
  );
};

export default NumberField;
